import { render, staticRenderFns } from "./TheMarkdown.vue?vue&type=template&id=2a51255e&scoped=true"
import script from "./TheMarkdown.vue?vue&type=script&lang=js"
export * from "./TheMarkdown.vue?vue&type=script&lang=js"
import style0 from "./TheMarkdown.vue?vue&type=style&index=0&id=2a51255e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a51255e",
  null
  
)

export default component.exports